export default __webpack_public_path__ + "images/L6.27b6cba.png";